import initialState from './initialstate';
import * as types from '../Actions/actiontypes';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskStatusAssigmentsReducer(state = initialState.taskStatusAssigments, action) {
	switch (action.type) {
		case types.HO_GET_STATUS_ASSIGNMENTS: {
			let statusAssigments = action.response;
			return _.cloneDeep(statusAssigments);
		}
		
		default:
			return state;
	}
}
